import { render, staticRenderFns } from "./WSwitch.vue?vue&type=template&id=70eddedd&"
import script from "./WSwitch.vue?vue&type=script&lang=ts&"
export * from "./WSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./WSwitch.vue?vue&type=style&index=0&id=70eddedd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports